//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatDate} from '../../../lib/date';
import VueUeditorWrap from 'vue-ueditor-wrap';
import fileUploader from '../../common-components/file-uploader';
import {getEmergencyContactInfo} from '../../../api/newOwner';

export default {
  name: 'reservationInfo',
  components: {
    VueUeditorWrap, fileUploader
  },
  filters: {
    formatDate(time, type) {
      const date = new Date(time);
      if (type === 1) {
        return formatDate(date, 'yyyy-MM-dd');
      }
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  },
  data() {
    return {
      loading: false,
      id: 0,
      saving: false,
      deliveryInfos: [],
      deliveryRecord: {},
      title: '',
      chuLi: {
        file: {associateType: 'DeliveryInfoFile'}
      },
      showChuLiModal: false,
      showChuLiInfoModal: false,
      chuliInfo: {},
      otherOwnerList: [],
      infoTitle: '',
      columns: [
        {type: 'index', align: 'center', width: 60},
        {title: '姓名', align: 'center', key: 'name'},
        {title: '手机号', align: 'center', key: 'phoneNumber'},
        {title: '证件类型', align: 'center', key: 'cardTypeStr'},
        {title: '证件号', align: 'center', key: 'cardNum'},
        {title: '证件', align: 'center', slot: 'IDImage'},
      ],
      emergencyContactInfo: {},
      rules: {
        deliveryDate: [{required: true, message: '请填写交房时间', trigger: 'change'}]
      },
      owners: []
    };
  },
  methods: {
    getDeliveryRecordById() {
      this.loading = true;
      abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordById?id=' + this.id).then(res => {
        this.deliveryRecord = {};
        this.deliveryRecord = res.data.result;
        this.getEmergencyContactInfo();
        this.getOwnersByRoomId(this.deliveryRecord.roomId);
      }).finally(() => {
        this.loading = false;
      });
    },
    getDeliveryInfoList() {
      this.loading = true;
      abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryInfoList?deliveryRecordId=' + this.id).then((resp) => {
        if (resp.data.result != null) {
          this.deliveryInfos = resp.data.result;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    showChuLi(chuliInfo) {
      this.chuliInfo = chuliInfo;
      // if (chuliInfo.operatorType==1){
      this.infoTitle = chuliInfo.operatorTypeStr;
      // }
      this.showChuLiInfoModal = true;
    },
    addChuLi(chuLi) {
      this.title = '预约受理';
      if (chuLi.operatorType === 1) {
        this.title = '客服接收';
      }
      if (chuLi.operatorType === 2) {
        this.title = '安排接待';
      }
      if (chuLi.operatorType === 3) {
        this.title = '接待反馈';
      }
      if (chuLi.operatorType === 5) {
        this.title = '客户评价';
      }
      if (chuLi.operatorType === 99) {
        this.title = '预约取消';
      }
      if (chuLi.operatorType === 7) {
        this.title = '资料审核';
      }
      if (chuLi.operatorType === 21) {
        this.title = '预约确认';
      }
      if (chuLi.operatorType === 30) {
        this.title = '确认交房';
      }
      chuLi.file = {associateType: 'DeliveryInfoFile'};
      this.chuLi = {};
      this.chuLi = chuLi;
      this.showChuLiModal = true;
    },
    saveDeliveryInfo(deliveryInfo) {
      if (deliveryInfo.operatorType === 5) {
        if (deliveryInfo.visitResult === 1) {
          deliveryInfo.operatorType = 4;
        } else {
          deliveryInfo.operatorType = 5;
        }
      }
      this.saving = true;
      abp.ajax
          .post('/api/services/app/DeliveryRecord/SaveDeliveryChuLi', deliveryInfo)
          .then(() => {
            this.showChuLiModal = false;
            this.$Notice.success({
              duration: 3,
              title: '保存成功'
            });
            this.chuLi = {
              file: {associateType: 'DeliveryInfoFile'}
            };
            this.getDeliveryRecordById();
            this.getDeliveryInfoList();
          })
          .finally(() => {
            this.saving = false;
          });
    },
    hasPermission(permission) {
      return abp.auth.isGranted(permission);
    },
    getOtherOwner() {
      let vm = this;
      abp.ajax.get('/api/services/app/DeliveryRecord/GetOtherOwnerByRecordId?recordId=' + this.id).then(res => {
        this.otherOwnerList = [];
        this.otherOwnerList.push(...res.data.result);
      }).finally(() => {

      });
    },
    // dataAudit(chuli) {
    //     const vm = this;
    //     this.$Modal.confirm({
    //         title: this.L('Tips'),
    //         content: '确认审核吗？',
    //         okText: this.L('Yes'),
    //         cancelText: this.L('No'),
    //         onOk: async () => {
    //
    //             abp.ajax.post('/api/services/app/DeliveryRecord/DataAudit?recordId=' + this.id).then(res => {
    //                 this.getDeliveryRecordById();
    //                 this.getDeliveryInfoList();
    //             }).finally(() => {
    //
    //             });
    //         }
    //     });
    //
    // },

    getEmergencyContactInfo() {
      getEmergencyContactInfo(this.deliveryRecord.roomId).then(res => {
        this.emergencyContactInfo = {};
        this.emergencyContactInfo = res.data.result;
      });
    },

    getOwnersByRoomId(roomId) {
      this.owners = []
      abp.ajax.get('/api/services/app/NewOwner/GetOwnersByRoomId?roomId=' + roomId).then(res => {
        this.owners = res.data.result;
      })
    }
  },
  created() {
    this.id = parseInt(this.$route.params.id) || 0;
    this.getDeliveryRecordById();
    this.getDeliveryInfoList();
    this.getOtherOwner();
  },
  watch: {}
};
